import { createSlice } from "@reduxjs/toolkit"

const missionBillingSlice = createSlice({
  name: 'missionBilling',
  initialState: {
    missionBillings: null,
    errors: []
  },
  reducers: {
    fullUpdate: (state, action) => {
      return { ...state, ...action.payload }
    },
    updateMissionBillings: (state, action) => {
      state.missionBillings = action.payload
    },
    addMissionBilling: (state, action) => {
      const missionBilling = action.payload
      state.missionBillings = { ...state.missionBillings, [missionBilling.id]: missionBilling }
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    }
  }
})

export const { addMissionBilling, fullUpdate, updateMissionBillings, updateErrors } = missionBillingSlice.actions

export default missionBillingSlice.reducer